(() => {
  const body = document.body;
  if (!body || !body.hasAttribute('data-prdl-customer')) return;
  const labels = body.dataset;
  const productPrices = new Map();
  const pendingPrices = new WeakSet();
  const syncFavoritePrices = () => {
    if (!window.PureRDLPriceDisplay) return;
    document.querySelectorAll('.wl-product-card').forEach(card => {
      const price = card.querySelector('.wl-product-price');
      const link = card.querySelector('a[href*="/products/"]');
      if (!price || !link || price.querySelector('[data-prdl-money]') || pendingPrices.has(price)) return;
      const productUrl = new URL(link.href, location.origin);
      if (productUrl.origin !== location.origin || !productUrl.pathname.includes('/products/')) return;
      productUrl.search = '';
      productUrl.hash = '';
      const endpoint = productUrl.pathname.replace(/\/$/, '') + '.js';
      pendingPrices.add(price);
      if (!productPrices.has(endpoint)) {
        productPrices.set(endpoint, fetch(endpoint, {credentials:'same-origin'})
          .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); }));
      }
      productPrices.get(endpoint).then(product => {
        if (!price.isConnected || price.querySelector('[data-prdl-money]')) return;
        const variantId = card.dataset.variantId;
        const variant = product.variants.find(item => String(item.id) === variantId);
        if (!variant || !Number.isFinite(variant.price)) return;
        const currency = labels.prdlFavoritesCurrency || 'EUR';
        price.replaceChildren(window.PureRDLPriceDisplay.createMoney(variant.price, variant.taxable !== false, currency));
      }).catch(() => {
        productPrices.delete(endpoint);
      }).finally(() => pendingPrices.delete(price));
    });
  };
  const labelButton = button => {
    const saved = button.dataset.added === 'true';
    const label = saved ? labels.prdlFavoritesRemove : labels.prdlFavoritesAdd;
    button.setAttribute('aria-label', label);
    button.setAttribute('aria-pressed', String(saved));
    button.title = label;
    if (button.matches('.wl-coll-btn')) {
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      if (!button.dataset.prdlKeyboard) {
        button.dataset.prdlKeyboard = 'true';
        button.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            button.click();
          }
        });
        button.addEventListener('keyup', event => {
          if (event.key === 'Enter' || event.key === ' ') event.stopPropagation();
        });
      }
    }
  };
  let scheduled = false;
  const sync = () => {
    scheduled = false;
    document.querySelectorAll('.wl-btn,.wl-coll-btn').forEach(labelButton);
    document.querySelectorAll('.wl-card-delete-btn').forEach(button => {
      button.setAttribute('aria-label', labels.prdlFavoritesRemove);
      button.title = labels.prdlFavoritesRemove;
    });
    syncFavoritePrices();
    const header = document.querySelector('#wl-header-icon-root');
    if (header) { header.setAttribute('aria-label', labels.prdlFavoritesTitle); header.title=labels.prdlFavoritesTitle; }
  };
  const observer = new MutationObserver(() => {
    if (!scheduled) { scheduled=true; requestAnimationFrame(sync); }
  });
  observer.observe(body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-added']});
  sync();
})();
